import React, { Dispatch, FC } from 'react';
import NumberFormat from 'react-number-format';

import classes from '../../asset/css/subscription-detail/pause.module.css';
import { ProductInfoViewType } from '../../types/view/product-info-view-type';
import { useSubscriptionPause } from '../../hooks/use-subscription-pause';
import { SubscriptionStatus } from '../../types/api/subscriptions-api-type';
import { Summary } from '../../hooks/use-subscription-summary';

export const PauseStatus: FC<{
  token: string,
  contractId: string,
  summary: Summary | undefined,
  products: ProductInfoViewType[],
  setSubscriptionStatus: Dispatch<SubscriptionStatus>
}> = ({ token, contractId, summary, products, setSubscriptionStatus }) => {

  const { subscriptionPauseCancel } = useSubscriptionPause(token, contractId)
  const handleClick = () => subscriptionPauseCancel(() => setSubscriptionStatus('ACTIVE'));

  return (
    <div className={classes.pause}>
      <h2 className={classes.pause_title}>お客様のBOXプランは一時停止中となっています。</h2>
      <p className={classes.pause_description}>
        自動決済の際に決済ができなかったなどの理由で、現在BOXプランを一時停止中にさせていただいています。<br/>
        BOXプランの継続をご希望の場合は「BOXプランを再開する」ボタンを押してください。
      </p>
      <h3 className={classes.pause_lead}>
        <span className={classes.pause_lead_text}>現在のBOXプランの内容</span>
        <span className={classes.pause_lead_totalPrice}>
          <span>合計金額: </span>
          <NumberFormat
            displayType='text'
            value={ summary ? summary.totalPrice + summary.deliveryPrice : '読み込み中' }
            thousandSeparator={true}
            prefix='￥'
          />
        </span>
      </h3>
      <ul className={classes.pause_list}>
        { products.map(product => (
        <li className={classes.pause_list_item}>
          <div 
            className={classes.pause_list_item_image}
            style={product.image ? { backgroundImage: `url(${product.image})` } : {}}
          />
          <div className={classes.pause_list_item_text}>
            <strong>{ product.productTitle }</strong><br/>
            <NumberFormat
              displayType='text'
              value={ product.price }
              thousandSeparator={true}
              prefix='￥'
            />
            × { product.quantity }個
          </div>
        </li>
        ))}
      </ul>
      <div className={classes.pause_submit}>
        <button 
          className={classes.pause_submit_button}
          onClick={handleClick}
        >BOXプランを再開する</button>
      </div>
    </div>
  )
};